import { useMemo } from "react";
import useTypedSearchParams from "@/features/invoices/hooks/use-typed-search-params";
import { SettlementManagementQuery } from "@/features/my-order/features/settlement-management/types";

const useSettlementManagementQuery = () => {
  const [query, setQuery] = useTypedSearchParams<SettlementManagementQuery>();
  const queryWithDefaults = useMemo<SettlementManagementQuery>(() => {
    const type = query.type ?? "FEE";

    if (type === "CREDIT") {
      return {
        ...query,
        type,
        orderBy: query.orderBy ?? "-issued_on",
      };
    }

    return {
      ...query,
      type,
    };
  }, [query]);

  return { query: queryWithDefaults, setQuery };
};

export default useSettlementManagementQuery;
